import { selectedTimeAtom } from "@/api/atoms";
import { useMediaQuery } from "@react-hookz/web";
import { motion } from "framer-motion";
import { useAtomValue } from "jotai";
import { Popup as MapboxPopup } from "react-map-gl";

interface PopupProps {
  lat: number;
  lng: number;
  counts: {
    yearCounts: {
      2020: number;
      2021: number;
      2022: number;
      2023: number;
      2024: number;
      2025: number;
    };
    lastReportedMonthCount: number;
  };
  details: string;
  location: string;
  onRemove?: () => void;
}

export function Popup(props: PopupProps) {
  const selectedTime = useAtomValue(selectedTimeAtom);
  const isSmallMobileDevice = useMediaQuery("(max-device-height: 650px)");
  const isMobileDevice = useMediaQuery("(max-device-width: 480px)");
  const offset = isSmallMobileDevice ? -90 : -35;

  const getCount = (counts, selectedTime) => {
    if (selectedTime === 7) {
      return counts.lastReportedMonthCount ?? 0;
    }

    if (counts.yearCounts) {
      if (typeof counts.yearCounts === "number") {
        return counts.yearCounts;
      }
      if (selectedTime === 1) {
        return counts.yearCounts["2020"];
      }
      if (selectedTime === 2) {
        return counts.yearCounts["2021"];
      }
      if (selectedTime === 3) {
        return counts.yearCounts["2022"];
      }
      if (selectedTime === 4) {
        return counts.yearCounts["2023"];
      }
      if (selectedTime === 5) {
        return counts.yearCounts["2024"];
      }
      if (selectedTime === 6) {
        return counts.yearCounts["2025"];
      }
    }

    return counts.lastReportedMonthCount ?? 0;
  };

  const count = getCount(props.counts, selectedTime);
  const isYourLocation = props.location === "Your Location";

  return (
    <MapboxPopup
      latitude={props.lat}
      longitude={props.lng}
      closeOnClick={false}
      anchor="bottom"
      offsetTop={offset}
      className="font-sans"
    >
      <motion.div
        className="rounded-md bg-white p-3"
        initial={{
          opacity: 0,
          y: 10,
        }}
        animate={{
          opacity: 1,
          y: 0,
        }}
        exit={{
          opacity: 0,
          y: 10,
        }}
        transition={{ duration: 0.2 }}
      >
        {isMobileDevice ? (
          <div className="popup">
            <p>
              <b>{props.location}</b>
            </p>
          </div>
        ) : (
          <div className="flex flex-col">
            <p>
              {isYourLocation && "You are in"} <b>{props.location}</b>
            </p>
            <hr className="my-2" />
            <div className="flex gap-3">
              <h2 className="text-3xl font-bold text-magenta">{count ?? 0}</h2>
              <div className="flex flex-col items-start justify-center text-xs">
                <b>
                  Reported Thefts (
                  {selectedTime === 1
                    ? "2020"
                    : selectedTime === 2
                      ? "2021"
                      : selectedTime === 3
                        ? "2022"
                        : selectedTime === 4
                          ? "2023"
                          : selectedTime === 5
                            ? "2024"
                            : selectedTime === 6
                              ? "2025"
                              : "December 2025"}
                  )
                </b>
                <p>{props.details}</p>
              </div>
            </div>
          </div>
        )}
      </motion.div>
      {!isYourLocation && (
        <button
          className="absolute right-0 top-0 grid size-6 place-content-center"
          onClick={props.onRemove}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            fill="#000000"
            viewBox="0 0 256 256"
          >
            <path d="M205.66,194.34a8,8,0,0,1-11.32,11.32L128,139.31,61.66,205.66a8,8,0,0,1-11.32-11.32L116.69,128,50.34,61.66A8,8,0,0,1,61.66,50.34L128,116.69l66.34-66.35a8,8,0,0,1,11.32,11.32L139.31,128Z" />
          </svg>
        </button>
      )}
    </MapboxPopup>
  );
}
